import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  emptyMessageContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default useStyles;
